//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MapMixin from '@/components/core/dtwin/map/mixin';
export default {
  name: 'IsHeatMonitoringMeterPointMap',
  mixins: [MapMixin],
  props: {
    detailsBaseLink: {
      type: String,
      required: false,
      default: 'is-heatmonitoring/meter-points'
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    mapStyle: function mapStyle() {
      if (!this.$store.state.app.mapStyle) {
        // TODO: use proper store.commit action to mutate vuex store
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$store.state.app.mapStyle = localStorage.getItem('mapStyle');
      }

      switch (this.$store.state.app.mapStyle) {
        case '2':
          return this.satellite;

        case '3':
          return this.streets;

        case '4':
          return this.dmStreets;

        default:
          return !this.$store.state.app.UiTheme ? this.light : this.dark;
      }
    }
  },
  watch: {},
  created: function created() {
    this.displayTwinPolygons = false;
  },
  methods: {
    editDtwin: function editDtwin(id) {
      this.$router.push({
        path: "/".concat(this.detailsBaseLink, "/").concat(id)
      });
    }
  }
};